import React, { useState } from 'react';

const AdminAiPromptModal = ({ onGenerate, onCancel, isGenerating }) => {
    const [summary, setSummary] = useState('');
    const [provider, setProvider] = useState('gemini'); // Default to Gemini

    const handleGenerate = () => {
        if (!summary.trim()) {
            alert('Please provide a summary.');
            return;
        }
        // Pass both the summary and the selected provider
        onGenerate(summary, provider);
    };

    return (
        <div className="admin-modal-overlay nested-modal-overlay">
            <div className="admin-modal-content" onClick={(e) => e.stopPropagation()}>
                <h2>Generate Article with AI</h2>
                <p>Enter a brief summary and select an AI provider. The AI will generate a title, tags, and a full article draft for you to review.</p>
                
                <div className="form-group">
                    <label htmlFor="ai-provider">Select AI Provider:     </label>
                    <select id="ai-provider" value={provider} onChange={(e) => setProvider(e.target.value)}>
                        <option value="gemini">Google Gemini 1.5 Pro</option>
                        <option value="openai">OpenAI GPT-4o</option>
                        <option value="groq">Groq Llama 3</option>
                    </select>
                </div>

                <div className="form-group">
                    <label htmlFor="ai-summary">Brief Summary</label>
                    <textarea 
                        id="ai-summary"
                        value={summary}
                        onChange={(e) => setSummary(e.target.value)}
                        rows="8"
                        className="admin-textarea" // Use consistent styling
                        placeholder="e.g., An article explaining the benefits of morning yoga for busy professionals, focusing on stress reduction and increased productivity."
                    />
                </div>
                <div className="form-actions">
                    <button type="button" onClick={onCancel} className="btn-secondary" disabled={isGenerating}>
                        Cancel
                    </button>
                    <button type="button" onClick={handleGenerate} className="btn-primary" disabled={isGenerating}>
                        {isGenerating ? 'Generating...' : 'Generate Article'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AdminAiPromptModal;
